var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgClose = function SvgClose(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Close' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-915.000000, -3440.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "952.558 3449 939 3462.558 925.442 3449 924 3450.442 937.558 3463.999 924 3477.558 925.442 3479 939 3465.442 952.558 3479 954 3477.558 940.442 3463.999 954 3450.442"
  })));
};
SvgClose = pure(SvgClose);
SvgClose.displayName = 'SvgClose';
export default SvgClose;